import { Link } from "react-router-dom";
import { PHILOSOPHER_PAGES } from "../data/philosopherPages";
import { PHILOSOPHERS } from "../data/philosophers";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

/**
 * /philosophers — index of the 8 profile pages, used both as a UX destination
 * (linked from the footer) and as an SEO hub that distributes link equity to
 * the 8 individual pages.
 */
export default function PhilosopherIndex() {
  return (
    <div className="relative z-10 mx-auto min-h-[100dvh] w-full px-5 py-14" data-testid="philosopher-index-screen">
      <SEOHead
        title="The 8 Philosophers — Personality Archetypes"
        description="Meet the eight great minds you can be matched with in The Philosopher Test: Marcus Aurelius, Nietzsche, Socrates, Epicurus, Beauvoir, Diogenes, Confucius, Arendt."
        path="/philosophers"
      />
      <div style={{ maxWidth: 780, margin: "0 auto" }}>
        <p className="text-[11px] font-medium uppercase" style={{ color: "var(--muted)", letterSpacing: "0.32em" }}>
          The Philosopher Test · Archetypes
        </p>
        <h1 className="mt-3 font-serif text-[36px] sm:text-[46px] leading-[1.08]" style={{ color: "var(--gold)" }}>
          The eight minds
        </h1>
        <p className="mt-4 max-w-xl text-[16px] leading-relaxed" style={{ color: "var(--text)" }}>
          The test matches you against these eight philosophers — the greatest characters in the
          Western and Eastern canons, each defined by a distinct trait signature. Pick the one
          that already sounds like you, or take the quiz and let the math decide.
        </p>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {PHILOSOPHERS.map((base) => {
            const page = PHILOSOPHER_PAGES[base.id];
            if (!page) return null;
            return (
              <Link
                key={base.id}
                to={`/philosophers/${page.slug}`}
                className="panel block transition-colors"
                data-testid={`card-${base.id}`}
                style={{ color: "var(--text)" }}
              >
                <p className="text-[10px] font-medium uppercase" style={{ color: "var(--gold)", letterSpacing: "0.32em" }}>
                  {page.archetype}
                </p>
                <h2 className="mt-2 font-serif text-[22px]" style={{ color: "var(--text)" }}>
                  {page.fullName}
                </h2>
                <p className="mt-3 text-[13px] leading-relaxed" style={{ color: "var(--muted)" }}>
                  {page.tagline}
                </p>
              </Link>
            );
          })}
        </div>

        <div className="mt-12 flex flex-col gap-3">
          <Link to="/" className="btn-primary text-center" data-testid="index-cta-take-test">
            Take The Philosopher Test
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
